import { ReactElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { Cell, Workbook, Worksheet, Style } from "./templates"; 
import { collect } from "helpers/collection";
import { makeid } from "helpers/random";

const URI = 'data:application/vnd.ms-excel;base64,';

function format(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
function base64(s) { return window.btoa(unescape(encodeURIComponent(s))) }
function getDataType(dataStyle){
  if(dataStyle){
    if(dataStyle.indexOf("currency") !== -1)return 'Number'
  }
  // dataType=='DateTime' || dataType=='Boolean' || dataType=='Error'
  return "";
}
function displayTextWidth(text, font) {
  let canvas = document.createElement("canvas");
  let context = canvas.getContext("2d");
  if(context){
    context.font = font;
    let metrics = context.measureText(text);
    return metrics.width;
  }
  return 0;
}
function mergeStyle(...arg){
  const style = document.createElement('span').style;
  for (const s of arg) {
    for (let index = 0; index < s.length; index++) {
      const nameString = s[index];
      style.setProperty(nameString,s.getPropertyValue(nameString));
    }
  }
  return style;
}
function getTableElement(table){
  const staticElement = renderToStaticMarkup(table);
  const output = document.createElement('div');
  output.innerHTML = staticElement;
  return output.firstChild
}
function addStyle(style, listStyle, dataStyle, dataBorder){
  //ss:Alignment, ss:Borders, ss:Font, ss:Interior, ss:NumberFormat, ss:Underline
  function getColor(color){
    if(color.indexOf("rgb")!==-1){
      let aux1 = color.split("(");
      if(aux1.length===2){
        let aux2 = aux1[1].split(")");
        if(aux2.length===2){
          let aux3 = aux2[0].split(",");
          if(aux3.length===3){
            let [r,g,b] = aux3.map(a=>parseInt(a).toString(16));
            return `#${r}${g}${b}`;
          }
        }
      }
    }
    return color;
  }
  
  function setFont(style){
    let font = ` ss:FontName="Calibri"`;
    if(style.fontWeight && style.fontWeight === "bold") font += ` ss:Bold="1"`; 
    if(style.color) font += ` ss:Color="${getColor(style.color)}"`;

    if(style.textDecoration){
      let p = style.textDecoration.split(" ");
      for (let i = 0; i < p.length; i++) {
        if(p[i] === "underline"){
          font += ` ss:Underline="Single"`; 
        }
      }
    }
    return `<Font${font}/>`;
  }

  function formatNumber(dataStyle){
    function formatCurrency(value){
      if(value==="BRL") return `<NumberFormat ss:Format="_-R$* #,##0.00_-;-R$* #,##0.00_-;R$* &quot;-&quot;??_-;_-@_-"/>`;
      if(value==="USD") return `<NumberFormat ss:Format="_-$* #,##0.00_-;-$* #,##0.00_-;$* &quot;-&quot;??_-;_-@_-"/>`;
      return ""
    }

    let r = "";
    if(dataStyle && dataStyle.split(":").length === 2){
      const [type, value] = dataStyle.split(":");
      if(r==="" && type==="currency") r = formatCurrency(value);
    }
    if(dataStyle === "percent"){
      r = `<NumberFormat ss:Format="Percent"/>`;
    }
    return r;
  }

  function setAlignment(style){
    let att = "";
    let is_att = false;
    if(style.textAlign) {
      is_att = true;
      if(style.textAlign === "center") att += ` ss:Horizontal="Center"`;
      if(style.textAlign === "left") att += ` ss:Horizontal="Left"`;
      if(style.textAlign === "right") att += ` ss:Horizontal="Right"`;
    }
    if(style.verticalAlign) {
      is_att = true;
      if(style.verticalAlign === "middle") att += ` ss:Vertical="Center"`;
      if(style.verticalAlign === "top") att += ` ss:Vertical="Top"`;
      if(style.verticalAlign === "bottom") att += ` ss:Vertical="Bottom"`;
    }

    if(is_att) return `<Alignment${att}/>`;
    return "";
  }

  function setBorder(border){
    if(border){
      let side = border.split(" ");
      if(side.length === 4){
        let r = "";
        let b = [
          '<Border ss:Position="Left" ss:LineStyle="Continuous" ss:Weight="1"></Border>',
          '<Border ss:Position="Top" ss:LineStyle="Continuous" ss:Weight="1"></Border>',
          '<Border ss:Position="Right" ss:LineStyle="Continuous" ss:Weight="1"></Border>',
          '<Border ss:Position="Bottom" ss:LineStyle="Continuous" ss:Weight="1"></Border>',
        ]
        for (let i = 0; i < side.length; i++) {
          const c = side[i];
          if(c === "1"){
            r += b[i];
          }
        }
        if(r !== ""){
          return `<Borders>${r}</Borders>`;
        }
      }
    }
    return "";
  }

  let elements = "";
  if(style){
    if(style.backgroundColor) elements += `<Interior ss:Color="${getColor(style.backgroundColor)}" ss:Pattern="Solid"/>`;
    elements += setAlignment(style);
    elements += setFont(style);
    elements += formatNumber(dataStyle);
    elements += setBorder(dataBorder);

    if(elements){
      let r = null;
      for (const style_aux of listStyle) {
        if(style_aux.values === elements) {
          r = style_aux;
          break;
        }
      }
      if(!r){
        let randid = `Style${makeid(10)}`;
        let s = format(Style,{randid, elements:elements});
        r = {element:s, id:randid, values:elements};
        listStyle.push(r);
      }
      return r;
    }
  }
  return null;
}
function extractStyleTag(dataValue,element){
  if(dataValue.indexOf("<b>") !== -1){
    dataValue = dataValue.replace("<b>","").replace("</b>","");
    element.style.fontWeight = "bold";
  }
  if(dataValue.indexOf("<i>") !== -1){
    dataValue = dataValue.replace("<i>","").replace("</i>","");
  }
  if(dataValue.indexOf("<u>") !== -1){
    dataValue = dataValue.replace("<u>","").replace("</u>","");
    element.style.textDecoration += " underline"
  }

  return dataValue;
}
function getPos(s){
  const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let col = "";
  let row = "";
  let result = 0;

  for (const c of s) {
    if(digits.indexOf(c.toUpperCase()) > -1){
      col += c;
    } else {
      row += c;
    }
  }

  for (let i = 0; i < col.length; i++) {
    const digit = col[i].toUpperCase();
    const value = digits.indexOf(digit);
    
    if (value === -1) {
      throw new Error("String hexadecimal inválida: " + col);
    }
    
    result = result * digits.length + value;
  }

  return [parseInt(row),result];
}
function getColCell(c){
  if (c < 0) {
    throw new Error("Número inválido: " + c);
  }
  
  const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let hexString = "";

  while (c > 0) {
    const remainder = c % digits.length;
    hexString = digits[remainder] + hexString;
    c = Math.floor(c / digits.length);
  }

  return hexString;
}
function mergeCol(l,row, index){
  if(!!l[index]){
    let listIndex = [];
    let cols = [];
    for (let i = 0; i < row.cols.length; i++) {
      if(!!row.cols[i]) {
        listIndex.push(i);
        cols[i] = row.cols[i];
      }
    }
    for (let i = 0; i < l[index].cols.length; i++) {
      if(!!l[index].cols[i] && listIndex.indexOf(i)!==-1) throw new Error(`data in the same cell (${getColCell(i)}${index})`);
      if(!!l[index].cols[i]){
        listIndex.push(i);
        cols[i] = l[index].cols[i];
      } 
    }

    if(cols.length > 0){
      l[index] = {
        cols,
        s:row.s
      };
    }
  } else {
    l[index] = row;
  }
}
function getFormula(f){
  const operators = ["/","*","+","-"];
  let [ e, ...l ] = f.split("");
  if(e === "="){
    let s_aux = "";
    let data= [];
    let s_open = false;
    for (let index = 0; index < l.length; index++) {
      const c = l[index];
      if(c === `"`){
        s_open = !s_open;
        if(!s_open){
          data.push("s:"+s_aux);
          s_aux = "";
        }
      } else {
        if(s_open){
          s_aux += c;
        } else {
          if(operators.indexOf(c) !== -1){
            if(s_aux === ""){
              data.push(c);
            } else {
              data.push("var:"+s_aux);
              data.push(c);
              s_aux = "";
            }
          } else {
            if(c === "("){
              data.push("f_o:"+s_aux);
              s_aux = "";
            } if(c === ")"){
              if(s_aux === ""){
                data.push("f_c");
              } else {
                data.push("var:"+s_aux);
                data.push("f_c");
                s_aux = "";
              }
            } else {
              s_aux += c;
            }
          }
        }
      }
    }
    if(s_aux !== ""){
      data.push("var:"+s_aux);
    }
    let r = "=";
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      if(d.indexOf("var:") !== -1) {
        let pos = getPos(d.replace("var:", ""));
        r+=`R${pos[0]}C${pos[1]+1}`
      } else if(d.indexOf("f_o:") !== -1) {
        let aux = d.replace("f_o:","");
        r+=`${aux}(`;
      } else if(d.indexOf("f_c") !== -1) {
        r+=`)`;
      } else {
        r += d.replaceAll('"',"&quot");
      }
    }
    return r;
  }
  
  return "";
}
function getFormula2(s, formulas){
  if(s.indexOf("%f") === 0){
    let [f,arg,func,id] = s.split(" ");
    const args = ["r","u"]
    if(args.indexOf(arg) !== -1){
      if(arg === 'r'){
        const funcs = ["r+"]
        if(funcs.indexOf(func) !== -1){
          formulas.push({
            range:true,
            id:id,
            func,
            s:`%f_${id}%`,
            v:[[0,0],[0,0]]
          })
          return `%f_${id}%`
        }
      } else {
        if(func.indexOf("[") === 0 && func.indexOf("]") === func.length-1){
          formulas.push({
            range:false,
            id:id,
            func,
            s:`%f_${id}%`,
            v:[]
          })
          return `%f_${id}%`
        }
      }
    }
  }
  return s;
}
function converterParaCelulaExcel(x, y, x2, y2) {
  // const coluna = String.fromCharCode(65 + x - 1);
  // const celulaExcel = coluna + y;
  // return y + coluna;
  let r = -y2+y;
  let c = -x2+x;
  return `R${r<0?`[${r}]`:(r>0?`[${r}]`:"")}C${c<0?`[${c}]`:(c>0?`[${c}]`:"")}`;
}
function setFormula(content, formulas, pos) {
  for (let i = 0; i < formulas.length; i++) {
    let f = formulas[i];
    if(f.range && f.v.length === 2 && f.func === "r+"){
      let v1 = converterParaCelulaExcel(f.v[0][0],f.v[0][1],pos.col,pos.row)
      let v2 = converterParaCelulaExcel(f.v[1][0],f.v[1][1],pos.col,pos.row)
      content = content.replace(f.s,`=SUM(${v1}:${v2})`)
    } else if(!f.range){
      let positions = f.v;
      let func = f.func;
      let calc = "";
      let res = "";
      for (let j = 1; j < func.length-1; j++) {
        let c = func[j];
        if(c === '+' || c === '-' || c === '*' || c === '/') {
          calc = c;
        } else {
          if(c === '.' && func[j+1] === '.' && c==='.' && func[j+2] === '.'){
            if(calc){
              res += `=(${positions.map(p=>converterParaCelulaExcel(p[0],p[1],pos.col,pos.row)).join(calc)})`
              j+=2;
            }
          } else {

          }
        }
      }
      content = content.replace(f.s,res);
      
    } else {
      throw new Error("erro formula")
    }
  }
  return content;
}
function changeFormula(id,formulas,pos){
  return formulas.map((f)=>{
    if(f.id === id){
      if(f.range){
        if(f.v[0][0] === 0) f.v[0][0] = pos.col
        if(f.v[0][1] === 0) f.v[0][1] = pos.row
        if(f.v[1][0] === 0) f.v[1][0] = pos.col
        if(f.v[1][1] === 0) f.v[1][1] = pos.row

        if(f.v[0][0] > pos.col) f.v[0][0] = pos.col;
        if(f.v[0][1] > pos.row) f.v[0][1] = pos.row;

        if(f.v[1][0] < pos.col) f.v[1][0] = pos.col;
        if(f.v[1][1] < pos.row) f.v[1][1] = pos.row;
      } else {
        f.v.push([pos.col,pos.row]);
      }
    }
    return f;
  })
}
function formatName(name){
  name = name.replaceAll(" ","_").toLowerCase();
  let types = {
    "%date":()=>{
      var m = new Date();
      var dateString =
        ("0" + m.getUTCDate()).slice(-2) + "/" +
        ("0" + (m.getUTCMonth()+1)).slice(-2) + "/" +
        m.getUTCFullYear() + " " +
        ("0" + m.getUTCHours()).slice(-2) + ":" +
        ("0" + m.getUTCMinutes()).slice(-2) + ":" +
        ("0" + m.getUTCSeconds()).slice(-2);
      return dateString;
    }
  }
  Object.keys(types).forEach((key)=>{
    if(name.indexOf(key) !== -1){
      name = name.replaceAll(key,types[key]())
    }
  })
  return name+".xls";
}

/**
 * Download excel file
 * @param {HTMLTableElement[]} tables list of tables
 * @param {string[]} wsnames list of tables name
 * @param {string} wbname file name
 * @returns 
 */
function ExportExcel(tables, wsnames, wbname){
  var workbookXML = "";
  var worksheetsXML = "";
  var listStyle = [];
  let formulas = [];
  
  for (var i = 0; i < tables.length; i++) {
    var rowsXML = [];
    var columns_width = [];
    let table = getTableElement(tables[i])
    let wsname = wsnames.length>i?wsnames[i]:null;
    
    let style_table = addStyle(table.style,listStyle);
    
    let cell_merge = {};

    for (var j = 0; j < table.rows.length; j++) {
      let row = table.rows[j];
      var dataPos = row.getAttribute("data-pos");
      if(!!dataPos){
        dataPos = `${parseInt(dataPos)-1}`;
      }
      let style_row = addStyle(mergeStyle(table.style,table.rows[j].style),listStyle);
      let row_data = !!rowsXML[dataPos?parseInt(dataPos):rowsXML.length]?rowsXML[dataPos?parseInt(dataPos):rowsXML.length]:{s:`<Row ss:Index="{index_col_add_after}">{cols_area}</Row>\n`,cols:[]};

      if(style_row){
        row_data.s = `<Row ss:StyleID="${style_row.id}" ss:Index="{index_col_add_after}">{cols_area}</Row>\n`;
      }
      let jump_col = 0;
      if(cell_merge[j] === undefined)cell_merge[j] = [];
      for (var k = 0; k < row.cells.length; k++) {
        if(row.cells[k].tagName === "TH"){
          row.cells[k].style.fontWeight = "bold";
        }
        var dataStyle = row.cells[k].getAttribute("data-style");
        var idToForm = row.cells[k].getAttribute("id-to-form");
        var dataHRef = row.cells[k].getAttribute("data-href");
        var dataPostCol = row.cells[k].getAttribute("data-pos");
        var dataBorder = row.cells[k].getAttribute("data-border");
        if(dataHRef)row.cells[k].style.textDecoration = "underline";

        var dataType = row.cells[k].getAttribute("data-type")??getDataType(dataStyle??undefined);
        
        var dataValue = row.cells[k].getAttribute("data-value");
        var dataFormula = row.cells[k].getAttribute("data-formula");
        if(dataFormula) dataFormula = getFormula2(dataFormula, formulas);
        var dataColspan = row.cells[k].getAttribute("colspan");
        var dataRowspan = row.cells[k].getAttribute("rowspan");

        dataValue = extractStyleTag((dataValue)?dataValue:row.cells[k].innerHTML,row.cells[k]);
        let style = addStyle(mergeStyle(table.style,row.style,row.cells[k].style), listStyle, dataStyle??undefined, dataBorder??undefined);

        dataFormula = (dataFormula)?dataFormula:(dataType==='DateTime')?dataValue:null;
        if(dataValue[0]==="="){
          dataFormula = getFormula(dataValue);
        }
        
        let index = ((k,j)=>{
          function v(i){
            return cell_merge[j].filter((cm)=>cm === i).length !== 0
          }
          let index = 0;
          while(v(k+index)){
            index++;
          }
          return k+index;
        })(k,j);
        for (let y = 0; y < (dataRowspan?parseInt(dataRowspan):1); y++) {
          if(cell_merge[j+y] === undefined) cell_merge[j+y] = [];
          for (let x = 0; x < (dataColspan?parseInt(dataColspan):1); x++) {
            if(cell_merge[j+y].indexOf(index+x) !== -1) throw new Error("cell error");
            cell_merge[j+y].push(index+x)
          }
        }

        let ctx = {  
          attributeStyleID: style?' ss:StyleID="'+style.id+'"':"",
          nameType: (dataType==='Number' || dataType==='DateTime' || dataType==='Boolean' || dataType==='Error')?dataType:'String', 
          attributeMergeAcross:dataColspan?` ss:MergeAcross="${parseInt(dataColspan)-1}"`:"",
          attributeMergeDown:dataRowspan?` ss:MergeDown="${parseInt(dataRowspan)-1}"`:"",
          data: (dataFormula)?'':dataValue, 
          attributeFormula: (dataFormula)?' ss:Formula="'+dataFormula+'"':'',
          attributeHRef: (dataHRef)?` ss:HRef="${dataHRef}"`:"",
          attributeIndex: ` ss:Index="{index_add_after}"`,
        };
        let k_jump = k+jump_col;
        if(dataPostCol){
          let [ row_index, col_index ] = getPos(dataPostCol);
          
          dataPos = `${row_index}`;
          if(!rowsXML[row_index-1]){
            rowsXML[row_index-1] = {
              s:`<Row ss:Index="{index_col_add_after}">{cols_area}</Row>`,
              cols: [],
            }
          }
          if(!!rowsXML[row_index-1].cols[col_index]){
            rowsXML[row_index-1].cols.splice(col_index,0,{
              s:format(Cell, ctx),
              idToForm,
            });
          } else {
            rowsXML[row_index-1].cols[col_index] = {
              s:format(Cell, ctx),
              idToForm
            };
          }
          k_jump = col_index;
        } else {
          row_data.cols[index] = {
            s:format(Cell, ctx),
            idToForm
          };
        }
        
        // col width
        let col_width_aux = displayTextWidth(ctx.data,"Calibri")/(dataColspan?parseInt(dataColspan):1)+(10*(dataColspan?parseInt(dataColspan):1));
        for(let t = 0; t < (dataColspan?parseInt(dataColspan):1); t++){
          if(columns_width.length <= (k_jump+t)) columns_width.push(col_width_aux);
          else{
            if(columns_width[k_jump+t] < col_width_aux) columns_width[k_jump+t] = col_width_aux;
          }
        }
        jump_col+=dataColspan?parseInt(dataColspan):0;
        if(columns_width[k_jump] < col_width_aux) columns_width[k_jump] = col_width_aux; 
      }
      mergeCol(rowsXML,row_data,dataPos?parseInt(dataPos):rowsXML.length);
    }
    let ctx = {
      nameWS: wsname || 'Sheet' + i, 
      attStyleTable: style_table?`ss:StyleID="${style_table.id}"`:"",
      columns: columns_width.map((v,index)=>{
        return `<Column ss:AutoFitWidth="1" ss:Width="${v.toFixed(2)}" ss:Index="${index+1}"/>\n`;
      }).join(""),
      rows:""
    };
    for (let r_i = 0; r_i < rowsXML.length; r_i++) {
      const r = rowsXML[r_i];
      if(r){
        for (let c_i = 0; c_i < r.cols.length; c_i++) {
          const c = r.cols[c_i];
          if(c){
            if(c.idToForm) formulas = changeFormula(c.idToForm,formulas,{row:r_i+1,col:c_i+1});
          }
        }
      }
    }
    ctx.rows = "";
    for (let r_i = 0; r_i < rowsXML.length; r_i++) {
      const r = rowsXML[r_i];
      if(r){
        let cols_area = "";
        for (let c_i = 0; c_i < r.cols.length; c_i++) {
          const c = r.cols[c_i];
          if(c){
            if(c.s.indexOf("ss:Formula") !== -1){
              c.s = setFormula(c.s, formulas, {row:r_i+1,col:c_i+1});
            }
            cols_area += format(c.s,{index_add_after:c_i+1});
          }
        }
        ctx.rows += format(
          r.s,
          {
            index_col_add_after:r_i+1,
            cols_area
          }
        )
      } else {
        ctx.rows += `<Row ss:Index="${r_i+1}"></Row>`;
      }
    }
    worksheetsXML += format(Worksheet, ctx);
  }
  // worksheetsXML = setFormula(worksheetsXML, formulas);
  let ctx = {created: (new Date()).getTime(), worksheets: worksheetsXML, moreStyle: collect(listStyle).pluck("element").join("")};
  workbookXML = format(Workbook, ctx);
  // console.log(workbookXML);
  
  return {
    download: ()=>{
      var link = document.createElement("a");
      link.href = URI + base64(workbookXML);
      link.download = formatName(wbname);
      link.target = '_blank';
      link.click();
    },
    toString: () => {
      return workbookXML;
    }
  }
}

export default ExportExcel;